import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {newsletterMailDelivery_template} from "../components/templates/newsletterMailDelivery_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;
const DELIVERY_STATUSES = {1: 'Pending', 2: 'Sent', 3: 'In Progress', 4: 'Error', 5: 'Canceled', 6: 'Pending'};
const DELIVERY_STATUSES_CLASSES = {1: 'icon i-hourglass', 2: 'icon i-check', 3: 'icon i-inprogress', 4: 'icon i-error', 5: 'icon i-cancel', 6: 'icon i-hourglass'};

export class newsletter_mail_delivery extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected newsletterMailDelivery_template: newsletterMailDelivery_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.newsletterMailDelivery_template = new newsletterMailDelivery_template("newsletterMailDelivery_template", this.viewModel, this)
        this.template = this.newsletterMailDelivery_template;
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Newsletter Campaigns");
        return [this.newsletterMailDelivery_template.build()];
    }


    protected getModuleName(): string {
        return "newsletter_mail_delivery";
    }

    fillPage() {
        this.newsletterMailDelivery_template.buildDatePickerCalendar();
        this.getNewsletterReferences();
    }

    protected filterList() {
        console.log(this.newsletterMailDelivery_template.builtTemplate.children)
        this.loadingIn(this.newsletterMailDelivery_template.builtTemplate.children.namedItem("list-results"));
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let url: string = '/api/brand/' + idBrand + "/newsletter/emails/deliveries/get/";
        let subViewModel = this.newsletterMailDelivery_template.getViewModelForRequest();
        this.sendFilterCall(url, subViewModel, this.onfilterListReturn, XMLHttpRequestHandler_requestType.GET, 'articles_30_day_performance');
    }

    protected onfilterListReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let totalCount = responseParsed.totalCount
                let totalPage = responseParsed.totalPage
                let deliveries = responseParsed.data;
                let summary = responseParsed.extraData;

                deliveries.forEach( x => x.statusClass = DELIVERY_STATUSES_CLASSES[x.idStatus]);

                deliveries.forEach( x =>  x.status = DELIVERY_STATUSES[x.idStatus]);


                obj.viewModel.newsletterMailDelivery_template.pagination.itemCount(totalCount);

                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100

                obj.newsletterMailDelivery_template.setResultInfo(totalCount, totalPage, execTime)

                obj.newsletterMailDelivery_template.setDeliveries(deliveries)

                obj.newsletterMailDelivery_template.setSummary(summary)

            });
            obj.loadingOut(obj.newsletterMailDelivery_template.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected getNewsletterReferences() {

        // LOADING : starts
        this.loadingIn(this.newsletterMailDelivery_template.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/references';
        let usrReq_params: Array<Array<string>> = [['references', 'permissions,templates,statuses,recipientsFilter,mailingLists,segments,campaigns,fields,operators,utmSources,profileOptions']];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onNewsletterRequestReturn;
        this.XHRHdl.execute();
    }

    public loadProfileOptions(field: string, callback: Function): void {
        let url = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/references/';
        let XHRHdl = new XMLHttpRequestHandler(url, [['profileField', field]], this);
        XHRHdl.onReadyStateFunction = (req, obj) => () => {
            obj.manageResponse(req, obj, () => callback(JSON.parse(req.request.response).data || []));
        };
        XHRHdl.execute();
    }

    public onNewsletterRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.newsletterMailDelivery_template.builtTemplate);

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);

                obj.newsletterMailDelivery_template.setPermissions(responseParsed.permissions);
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getSearchPresetsListData();
            })
        }
    }
    protected newsletterMailDelivery_templateReorder() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.filterList()
    }

    protected paginationOnPageClick() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.filterList();
    }

    protected cancelNewsletterMail(data) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url = "/api/brand/" + idBrand + "/newsletter/delivery/cancel/" + data.id + "/"
        let formReq_params: Array<Array<string>> = [];

        this.loadingIn(this.newsletterMailDelivery_template.builtTemplate.children.namedItem("list-results"));
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);
                    console.log(responseParsed)

                    obj.getVnAppZone().notification =
                        new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS,
                            "Newsletter " + "<strong>" + responseParsed.newsletterMail.subject + "</strong>" + "was successfully canceled");
                    obj.getVnAppZone().showNotificationToModule()
                    obj.filterList();
                })

                // obj.loadingOut(obj.newsletterMailDelivery_template.builtTemplate.children.namedItem("list-results"));

            }
        });
        XHRHdl.execute();

    }

    protected filterSimpleOnChange(idElement){

        this.viewModel.newsletterMailDelivery_template.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected updateFilters(responseParsed: any){

        this.newsletterMailDelivery_template.setTemplateFilterItems(responseParsed.templates);
        this.newsletterMailDelivery_template.setStatusFilterItems(responseParsed.statuses);
        this.newsletterMailDelivery_template.setRecipientFilterItems(responseParsed.recipientsFilter);
        this.newsletterMailDelivery_template.setTargetingReferences(responseParsed);
    }

    protected filterDateOnChange(){
        this.viewModel.newsletterMailDelivery_template.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterMultipleSelectorOnChange(){
        this.viewModel.newsletterMailDelivery_template.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterByUrl(){
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){
        this.newsletterMailDelivery_template.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected setDefaultStatusFilters(){
        this.newsletterMailDelivery_template.setDefaults();
    }

    protected getSearchPresetsListData(): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.newsletterMailDelivery_template.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdl.execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.newsletterMailDelivery_template.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected saveSearchPreset(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.newsletterMailDelivery_template.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetArticles
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.newsletterMailDelivery_template.addCreatedPresetToList(response);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onPostFavoriteSearchPresetArticles
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onPostFavoriteSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/newsletter_mail_delivery.ts